/* eslint-disable @typescript-eslint/no-explicit-any */

export interface ErrorWithCode<Args extends unknown[], TData extends Record<string, unknown> = Record<string, never>> {
  readonly prototype: Error & TData;
  new (...args: Args): Error & TData;
}

export function makeErrorWithCode<Args extends unknown[]>(
  code: string,
  getMessage: (...args: Args) => string,
): ErrorWithCode<Args>;
export function makeErrorWithCode<Args extends unknown[], TData extends Record<string, unknown>>(
  code: string,
  getMessage: (...args: Args) => string,
  getData: (...args: Args) => TData,
): ErrorWithCode<Args, TData>;
export function makeErrorWithCode<Args extends unknown[], TData extends Record<string, unknown>>(
  code: string,
  getMessage: (...args: Args) => string,
  getData?: (...args: Args) => TData,
): any {
  return class extends Error {
    public constructor(...args: Args) {
      super(getMessage(...args));
      if (getData !== undefined) {
        for (const [key, value] of Object.entries(getData(...args))) {
          Object.defineProperty(this, key, {
            value,
            configurable: false,
            enumerable: true,
            writable: false,
          });
        }
      }
    }

    public get name(): string {
      return `${this.constructor.name} [${code}]`;
    }

    public get code(): string {
      return code;
    }
  };
}

/* eslint-enable @typescript-eslint/no-explicit-any */
